<template>
<div class="set-user-message-page">
  <div class="row top-bar">
    <div class="row logo-container" >
      <router-link to="/">
        <img class="logo" src="../assets/img/logo.svg" alt="shannon logo"/>
      </router-link>
      <router-link to="/">
        <div class="logo-text">SHANNON.AI</div>
      </router-link>
    </div>
  </div>
  <div class="content-body" v-if="showVerifyTelNumber">
    <div class="content-body-message">开通试用账号之前请验证手机号是否有权限！</div>
    <div class="login-page_right_container_content">
      <div class="login-page_right_container_content_title password">
        手机号
      </div>
      <div class="login-page_right_container_content_input telNumber">
        <div class="get-code">
          <span @click="onCheckTelNumberClick">验证手机号</span>
        </div >
        <el-input
          @focus="verifyTleNumberFocus"
          v-model="verifyTleNumber"
          :class="{'login-input-error':!verifyTleNumberError}"
          placeholder="请输入手机号"
          @keyup.enter.native="onCheckTelNumberClick"
        >
        </el-input>
      </div>
      <div class="error-message" :class="{isError:verifyTleNumberError}">{{verifyTleNumberErrorMessage}}</div>
    </div>
    <button v-if="showAllowRegisterBtn" class="login-page_right_container_btn" :class="{'login-page-btn':true}" @click="toAllowRegister">确定</button>
  </div>
  <div class="content-body" v-if="!showVerifyTelNumber">
    <div class="content-body-message">请填写试用账号信息</div>
    <div class="login-page_right_container_content">
      <div class="login-page_right_container_content_title">
        手机号
      </div>
      <div class="login-page_right_container_content_input telNumber row">
        <el-input
          v-model="telNumber"
          @focus="loginInputFocus"
          :class="{'login-input-error':!telNumberError}"
          placeholder="请输入手机号"
        ></el-input>
      </div>
      <div class="error-message" :class="{isError:telNumberError}">{{telNumberErrorMessage}}</div>

      <div class="login-page_right_container_content_title password">
        用户名
      </div>
      <div class="login-page_right_container_content_input telNumber">
        <el-input
          @focus="loginInputFocus"
          v-model="username"
          :class="{'login-input-error':!usernameError}"
          placeholder="请输入用户名"
          @keyup.enter.native="onAllowRegisterClick"
        >
        </el-input>
      </div>
      <div class="error-message" :class="{isError:usernameError}">{{usernameErrorMessage}}</div>

      <div class="login-page_right_container_content_title password">
        公司名
      </div>
      <div class="login-page_right_container_content_input telNumber">
        <el-input
          @focus="loginInputFocus"
          v-model="companyName"
          :class="{'login-input-error':!companyNameError}"
          placeholder="请输入所属公司名"
          @keyup.enter.native="onAllowRegisterClick"
        >
        </el-input>
      </div>
      <div class="error-message" :class="{isError:companyNameError}">{{companyNameErrorMessage}}</div>
      
      <div class="login-page_right_container_content_title password">
        账号有效期
      </div>
      <div class="block">
        <el-date-picker
          v-model="time"
          align="left"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
          :class="{'login-input-error':!timeError}"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
    </div>
    <div class="error-message" :class="{isError:timeError}">{{timeErrorMessage}}</div>
    <button class="login-page_right_container_btn" :class="{'login-page-btn':telNumber&&username&&companyName&&time}" @click="onAllowRegisterClick">确定</button>
  </div>
</div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      timeErrorMessage: '',
      timeError: true,
      verifyTleNumberErrorMessage: '',
      showAllowRegisterBtn: false,
      verifyTleNumberError: true,
      verifyTleNumber: '',
      showVerifyTelNumber: true,
      telNumber: '',
      username: '',
      companyName: '',
      time: '',
      telNumberError: true,
      telNumberErrorMessage: '',
      usernameError: true,
      usernameErrorMessage: '',
      companyNameError: true,
      companyNameErrorMessage: '',
      dateError: true,
      dateErrorMessage: '',
      pickerOptions: {
        disabledDate: (time) => {
          const curDate = (new Date()).getTime();
          const six = 3 * 365 * 24 * 3600 * 1000;
          const sixMonths = curDate + six;
          return time.getTime() < Date.now() || time.getTime() > sixMonths;
        },
        shortcuts: [{
          text: '7天',
          onClick(picker) {
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', end);
          }
        }, {
          text: '半个月',
          onClick(picker) {
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 15);
            picker.$emit('pick', end);
          }
        }, {
          text: '一个月',
          onClick(picker) {
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', end);
          }
        }, {
          text: '半年',
          onClick(picker) {
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 180);
            picker.$emit('pick', end);
          }
        }, {
          text: '一年',
          onClick(picker) {
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 356);
            picker.$emit('pick', end);
          }
        }, {
          text: '三年',
          onClick(picker) {
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 3);
            picker.$emit('pick', end);
          }
        }]
      }
    };
  },
  methods: {
    onCheckTelNumberClick() {
      if (!this.verifyTleNumber) {
        this.verifyTleNumberError = false;
        this.verifyTleNumberErrorMessage = '手机号码不能为空';
      } else {
        QuestionQuery.checkPermissions(this.verifyTleNumber).then(res => {
          if (res.status === -1) {
            this.verifyTleNumberError = false;
            this.verifyTleNumberErrorMessage = res.msg;
          } else {
            this.showAllowRegisterBtn = true;
            this.$message.success('验证成功');
          }
        });
      }
    },
    toAllowRegister() {
      this.showVerifyTelNumber = false;
    },
    verifyTleNumberFocus() {
      this.verifyTleNumberError = true;
      this.verifyTleNumberErrorMessage = '';
    },
    onAllowRegisterClick() {
      if (!/^1[3456789]\d{9}$/.test(this.telNumber)) {
        this.telNumberError = false;
        this.telNumberErrorMessage = '请输入正确的手机号码';
      } else if (!this.telNumber) {
        this.telNumberError = false;
        this.telNumberErrorMessage = '手机号码不能为空';
      } else if (!this.username) {
        this.usernameError = false;
        this.usernameErrorMessage = '用户名不能为空'; 
      } else if (!/^[\u4e00-\u9fa5_0-9A-Za-z_@.]{2,10}$/.test(this.username)) {
        this.usernameError = false;
        this.usernameErrorMessage = '用户名必须是2-10位之间的中文、字母、数字、下划线、@、.'; 
      } else if (!this.companyName) { 
        this.companyNameError = false;
        this.companyNameErrorMessage = '用户名不能为空'; 
      } else if (!/^[\u4e00-\u9fa5_0-9A-Za-z_@.]{1,15}$/.test(this.companyName)) { 
        this.companyNameError = false;
        this.companyNameErrorMessage = '公司名长度不能超过15'; 
      } else if (!this.time) { 
        this.$message.warning('截止日期不能为空');
      } else {
        const params = {
          phoneNumber: this.telNumber,
          username: this.username,
          companyName: this.companyName,
          expirationTime: this.time
        };
        QuestionQuery.allowRegister(params).then(res => {
          if (res.status === -1) {
            this.telNumberError = false;
            this.telNumberErrorMessage = res.msg;
          } else {
            this.$message.success('添加成功');
          }
        });
      }
    },
    loginInputFocus() {
      this.telNumberError = true;
      this.telNumberErrorMessage = '';
      this.usernameError = true;
      this.usernameErrorMessage = '';
      this.companyNameError = true;
      this.companyNameErrorMessage = '';
    }
  }
};
</script>

<style lang="scss" scoped>
  $bgColor: #343239;
.set-user-message-page {
  width: 100%;
  height: 100%;
  min-width: 840px;
  min-height: 550px;
  background-color: $bgColor;
  .top-bar {
    height: 64px;
    justify-content: space-between;
    align-items: center;
    padding: 0 48px;
    border-bottom: 1px solid #656164;
    
    z-index: 1;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;

    .logo-container {
      height: 26px;
      align-items: center;

      .logo {
        display: block;
        width: 26px;
        height: 26px;
      }

      .logo-text {
        margin-left: 8px;
        width: 215px;
        font-weight: bold;
        color: #45a8cc;
      }
    }
  }
  .content-body {
    width: 486px;
    margin: 0 auto;
    padding-top:96px;
    .content-body-title {
      font-size: 28px;
      letter-spacing: 2px;
      color: #ffffff;
    }
    .content-body-message {
      padding-top:8px;
      padding-bottom:32px;
      color: #ffffff;
      font-size: 16px;
      letter-spacing: 1.1px;
    }
  }
}  


@import "./../scss/color.scss";
@import "./../scss/mixin.scss";

.login-page {
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 840px;
  min-height: 550px;
  font-family:sans-serif;
  &_left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
    height: 100%;
    background: url("./../assets/img/bg.jpg") no-repeat;
    background-size: cover;
    &_content {
      width: 156px;
      height: 233px;
      margin-top: -20%;
      &_logo {
        width: 156px;
        height: 162px;
        background: url("./../assets/img/login-logo.svg") no-repeat;
      }
      &_line {
        height: 1px;
        width: 64px;
        background: #ffffff;
        margin: 22px auto;
      }
      &_text {
        width: 156px;
        height: 22px;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 1px;
        color: #fff;
        font-weight: normal;
        text-align: center;
      }
    }
  }
  &_right {
    position: relative;
    width: 60%;
    height: 100%;
    background: #333138;
    .register-btn {
      position: absolute;
      top: 6%;
      right: 10%;
      width: 76px;
      height: 48px;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
      background-color: #423f43;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
      &:hover{
        background: #45a8cc;
      }
      &:active{
        background: #368cab;
      }
    }
    &_container {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translateX(-50%, -50%);
      -moz-transform: translateX(-50%, -50%);
      -webkit-transform: translateX(-50%, -50%);
      -o-transform: translateX(-50%, -50%);
      width: 486px;
      height: 452px;
      &_title {
        font-size: 28px;
        font-weight: bold;
        line-height: 40px;
        color: #ffffff;
        font-family:sans-serif;
      }
      &_header {
        margin-top: 7px;
        font-size: 16px;
        font-weight: 100;
        color: #ffffff;
        letter-spacing: 1.1px;
        a {
          letter-spacing: 1.1px;
          color: #4a90e2;
          text-decoration: none;
          float: right;
        }
      }
      &_content {
        padding-bottom: 64px;
        &_title {
          height: 20px;
          font-size: 14px;
          color: #83898b;
          a {
            letter-spacing: 1.1px;
            color: #4a90e2;
            text-decoration: none;
            float: right;
          }
        }
        &_input {
          margin-top: 4px;
          /deep/ .el-input {
            .el-input__inner {
              // padding-left: 118px;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-left-width: 0;
              border-bottom-left-radius: 4px;
              border-top-left-radius: 4px;
              border-left-width: 4px;
              background-color: #27252a !important;
            }
          }
        }
        .password {
          margin-top: 32px;
        }
      }
      &_btn {
        width: 486px;
        height: 56px;
        background-color: #423f43;
        box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
        border-radius: 4px;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.3);
        border: none;
        letter-spacing: 1.4px;
        &:focus {
          outline: 0;
          background-color: #423f43;
        }
        &:hover {
          background-color: #423f43;
          box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
        }
        &:active {
          background-color: #423f43;
          box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
        }
      }
      .forget-password {
        margin-top: 16px;
        display: block;
        width: 100%;
        letter-spacing: 1px;
        color: #4a90e2;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}



/deep/ .el-input {
  .el-input__inner {
    height: 48px;
    line-height: 48px;
    color: #fff;
    background: #27252a;
    border: 1px solid transparent;
    border-color:#585659;
    border-right-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
    &::-webkit-input-placeholder {
      color: #b1c2c9;
      font-size: 14px;
    }
    &:hover {
      border-color: #585659;
      border: 1px solid #585659;
    }
    &:focus {
      border-color: #45a8cc;
    }
    &::-webkit-input-placeholder {
      color: #727273;
      font-size: 14px;
    }
  }
}
.login-input-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}
.tel-input-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}

.regist-tel-input-right {
  /deep/ .el-input__inner {
    border-color: #7ed321;
    &:hover {
      border-color: #7ed321;
    }
  }
}
.password-input-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}
.password-repeat-error {
  /deep/ .el-input__inner {
    border-color: #f27272;
    &:hover {
      border-color: #f27272;
    }
  }
}
.error-message {
  margin-top: 1px;
  height: 24px;
  padding-left: 8px;
  line-height: 24px;
  background-color: rgba(242, 114, 114, 0.2);
  border-radius: 4px;
  font-size: 14px;
  letter-spacing: 1px;
  color: #f27272;
}
.isError {
  visibility: hidden;
}
.password {
  /deep/ .el-input {
    .el-input__inner {
      // padding-left: 118px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-width: 0;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      border-left-width: 4px;
    }
  }
}
.telNumber {
  position: relative;
  .local-code {
    position: absolute;
    top: 14px;
    left: 16px;
    width: 100px;
    height: 20px;
    padding-left: 16px;
    line-height: 20px;
    font-size: 14px;
    color: #161e1f;
    z-index: 100;
    span {
      display: inline-block;
      width: 1px;
      height: 20px;
      position: absolute;
      top: 0px;
      right: 0;
      background: #585659;
    }
  }
  /deep/ .el-input {
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left-width: 0;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      border-left-width: 4px;
      background-color: #27252a !important;
    }
  }
}
.show-second {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 128px;
  height: 36px;
  padding: 8px 12px;
  border-radius: 2px;
  color: #45a8cc;
  background-color: #423f43;
  z-index:1;
  text-align: center;
  font-size: 14px;
}
.get-code {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 128px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 2px;
  color: #45a8cc;
  background-color: #423f43;
  z-index:1;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: #545155;
  }
  &:active {
    background-color: #38363c;
  }
}
.auto-login-checkbox {
  /deep/.el-checkbox {
    .el-checkbox__input {
      .el-checkbox__inner {
        background-color: #27252a !important;
      }
    }
  }
}
.login-page-btn {
  background-color: #45a8cc;
  box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: #3cbeed;
    box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
  }
  &:active {
    background-color: #368cab;
    box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
  }
  @include buttonEffect;
}
/deep/.el-input.is-disabled .el-input__inner {
  border-color: #423f43;
}
  


</style>
